import {
  CUSTOM_ELEMENTS_SCHEMA,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { IonicModule, ModalController } from '@ionic/angular';
import { SwiperPhoto } from '@smartflip/data-models';
import { PhotoCarouselComponent } from '../photo-carousel/photo-carousel.component';

@Component({
  imports: [IonicModule, PhotoCarouselComponent],
  selector: 'smartflip-photo-carousel-modal',
  templateUrl: './photo-carousel-modal.component.html',
  styleUrls: ['./photo-carousel-modal.component.scss'],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class PhotoCarouselModalComponent implements OnInit {
  public activeSlideIndex: number = 0;

  constructor(private modalController: ModalController) {}

  @Input() photos: SwiperPhoto[] = [];

  public closeModal(selectedImgUrl?: string) {
    this.modalController.dismiss(selectedImgUrl);
  }

  public selectForThumbnail() {
    this.closeModal(this.photos[this.activeSlideIndex].url);
  }

  public updateActiveIndex(sliderIndex: number) {
    this.activeSlideIndex = sliderIndex;
  }

  ngOnInit(): void {
    // Component initialization
    if (!this.photos || this.photos.length === 0) {
      console.warn('No photos provided to carousel modal');
    }
  }
}
